// extracted by mini-css-extract-plugin
module.exports = {"navTabs":"Skills_nav-tabs__vYznf","navItem":"Skills_nav-item__1mnIe","navLink":"Skills_nav-link__3-cfi","active":"Skills_active__1X1Ry","tabContent":"Skills_tab-content__3Nz-B"};